const MULTIPLIER_UP_TO_150K = 1.5;
const MULTIPLIER_OVER_150K = 2;

/**
 * Normalized (exchange?) rate to USD, based on Routing by Revenue Notion page
 * https://www.notion.so/wayflyer/Revenue-Based-Routing-70c77008007d41638521202b1045d9d8
 * e.g.
 * 10K EUR / 10K USD = 1
 * 12.5K CAD / 10K USD = 1.25
 * 7.5K GBP / 10K USD = 0.75
 * 68.5K DKK / 10K USD = 6.85
 * 100K SEK / 10K USD = 10
 * ...
 */
const NormalizedRateToUSD: Record<string, number> = {
  USD: 1,
  CAD: 1.25,
  GBP: 0.75,
  AUD: 1.25,
  EUR: 1,
  DKK: 6.85,
  SEK: 10,
} as const;

export function normalizeToUSD(amount: number, currencyCode: string) {
  if (!amount || !currencyCode || !NormalizedRateToUSD[currencyCode]) {
    return 0;
  }
  return amount / NormalizedRateToUSD[currencyCode];
}

export const calculateEligibleAmount = (
  reportedRevenue?: number | null,
  reportedRevenueCurrency?: string | null,
  indicativeOfferAmount?: number | null,
  indicativeOfferCurrency?: string | null
) => {
  const reportedRevenueCurrencyOrUsd = reportedRevenueCurrency ?? "USD";
  if (indicativeOfferAmount) {
    return {
      eligibleAmount: indicativeOfferAmount,
      eligibleCurrency: indicativeOfferCurrency ?? reportedRevenueCurrencyOrUsd,
    };
  }
  const reportedRevenueOrZero = reportedRevenue ?? 0;
  return {
    eligibleAmount: Math.round(
      reportedRevenueOrZero *
        (normalizeToUSD(reportedRevenueOrZero, reportedRevenueCurrencyOrUsd) > 150_000
          ? MULTIPLIER_OVER_150K
          : MULTIPLIER_UP_TO_150K)
    ),
    eligibleCurrency: reportedRevenueCurrencyOrUsd,
  };
};
